import SavedReportsLibraryContainer from '@components/containers/Reports/SavedReportsLibraryContainer';
import AppLayout from '@layouts/AppLayout';

export default function SavedReportsLibrary() {
    return (
        <AppLayout>
            <SavedReportsLibraryContainer />
        </AppLayout>
    );
}
